import Skeleton from "react-loading-skeleton";
import { colors } from "../../util/SkeletonColor";

const ToggleSwitch = (props) => {
  if (props.loading) {
    return <Skeleton width={40} height={20} borderRadius={20} baseColor={colors?.baseColor} highlightColor={colors?.highlightColor} />;
  }

  return (
    <>
      <label class="switch">
        <input
          type="checkbox"
          checked={props.value}
          onClick={props.onClick}
          className="checkbox"
          disabled={props.disabled}
        />
        <div class="slider"></div>
      </label>

    
    </>
  );
};

export default ToggleSwitch;
